import React from 'react';
import { Space, Tag } from "antd";
import { ColumnsType } from "antd/es/table";
import { EntityId } from "@reduxjs/toolkit";
import Table from "src/componets/Table";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { ButtonEdit } from "src/componets/Buttons";
import {
  setEditId,
  FeatureFlagSettingInterface
} from "src/store/callrecorder/featureFlagSettingsSlice";
import usePermissions from "src/hooks/usePermissions";
import { formattedDate } from "src/helpers/DateHelpers";
import Pagination from "src/componets/Pagination";

interface ListTableInterface {
  className?: string;
  limit: number;
}

const _ListTable = ({ className, limit }: ListTableInterface) => {
  const dispatch = useAppDispatch();
  const ids   = useAppSelector(state => state.callrecorder.featureFlagSettings.ids);
  const flags = useAppSelector(state => state.callrecorder.featureFlagSettings.entities);
  const count = useAppSelector(state => state.callrecorder.featureFlagSettings.count);
  const { write_callrecorder } = usePermissions();
  const data  = ids ? ids.map(id => flags[id]) : [];

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  const columns: ColumnsType<FeatureFlagSettingInterface> = [
    {
      key: 'name',
      title: 'Name',
      render: (_, { name }) => <code>{name}</code>,
      width: 220
    },
    {
      key: 'description',
      title: 'Description',
      render: (_, { description }) => <small>{description || '—'}</small>,
      ellipsis: true
    },
    {
      key: 'default_enabled',
      title: 'Default',
      render: (_, { default_enabled }) => (
        default_enabled
          ? <Tag color='success'>on</Tag>
          : <Tag color='default'>off</Tag>
      ),
      width: 90
    },
    {
      key: 'updated_at',
      title: 'Updated',
      render: (_, { updated_at }) => <small>{formattedDate(updated_at).dateTime}</small>,
      width: 140
    },
    ...(write_callrecorder ? [{
      key: 'action',
      title: 'Action',
      render: (_: any, { id }: FeatureFlagSettingInterface) => (
        <Space size="middle">
          <ButtonEdit key='button-edit' onClick={() => onClickEdit(id)} />
        </Space>
      ),
      width: 100
    }] : []),
  ];

  return (
    <div className={className}>
      <Table
        rowKey='id'
        columns={columns}
        dataSource={data}
        sort_keys={['updated_at']}
      />

      <Pagination className='v-mt-10' total={count} size={limit} />
    </div>
  )
}

export default _ListTable;
